<div class="card" role="button" routerLink="/article/{{article.id}}/{{encodeURIComponent(article.title.slice(0,55))}}">
  <div class="featured-img">
    <img [appImagePlaceholder]="getArticleImage(article)" class="card-img-top featured-img" alt="featured article" />
  </div>
  <div class="card-body">
    <h5 class="card-title pb-4 line-clamp-1">
      {{article.title}}
    </h5>
    <p class="card-text line-clamp-3">
      {{article.description | htmlToText}}
    </p>
  </div>
</div>
